export const usernameregex =/^[A-Za-z0-9]+$/;
export const emailregex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const mobileregex = /^\d{10}$/
export const pincoderegex = /^\d{6}$/
export const nameregex = /^[A-Za-z0-9'-_ ]{2,150}$/;
export const titleRegex = /^[A-Za-z0-9\s]{3,}$/;
export const descriptionRegex = /^[A-Za-z0-9\s.,?!'"\-]{3,}$/;
export const addressregex = /^[A-Za-z0-9\s.,?!'"\-]{3,}$/;
export const pecentageregex = /^(?:0?[1-9]|[1-9]\d|99)$/
export const priceRegex = /^(?:[1-9]\d{0,6}|9999999)$/


export const loadingTime = 500

export const  isValidDateOfBirth =(value) =>{
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    
    if (!dateRegex.test(value)) {
        return false; 
    }

    const today = new Date();
    const birthDate = new Date(value);

    // Calculate age based on year difference
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age >= 18;
}


export const  isValidStudentDateOfBirth =(value) =>{
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    
    if (!dateRegex.test(value)) {
        return false; // Invalid date format
    }

    const today = new Date();
    const birthDate = new Date(value);

    // Calculate age based on year difference
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age >= 2;
}